/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopCompanyJudgmentsDto
 */
export interface TopCompanyJudgmentsDto {
    /**
     * 
     * @type {string}
     * @memberof TopCompanyJudgmentsDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof TopCompanyJudgmentsDto
     */
    companyName: string;
    /**
     * 
     * @type {number}
     * @memberof TopCompanyJudgmentsDto
     */
    judgmentsCount: number;
}

/**
 * Check if a given object implements the TopCompanyJudgmentsDto interface.
 */
export function instanceOfTopCompanyJudgmentsDto(value: object): value is TopCompanyJudgmentsDto {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('judgmentsCount' in value) || value['judgmentsCount'] === undefined) return false;
    return true;
}

export function TopCompanyJudgmentsDtoFromJSON(json: any): TopCompanyJudgmentsDto {
    return TopCompanyJudgmentsDtoFromJSONTyped(json, false);
}

export function TopCompanyJudgmentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopCompanyJudgmentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'judgmentsCount': json['judgmentsCount'],
    };
}

export function TopCompanyJudgmentsDtoToJSON(value?: TopCompanyJudgmentsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'judgmentsCount': value['judgmentsCount'],
    };
}

